import { createFileRoute } from '@tanstack/react-router'
import { PlanningCenterSettings } from '../components/platform/PlanningCenterSettings.tsx'

export const Route = createFileRoute('/_authed/_shell/settings/planning-center')({
  component: PlanningCenterSettings,
})
